export default __webpack_public_path__ + "static/media/text-align-left-16.340a6406.svg";